import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import useCreateClient from "./useCreateClient";

export type CreateClientForm = {
	clientName: string;
	email: string;
};

export default function useCreateClientForm() {
	const schema = Yup.object().shape({
		clientName: Yup.string().required("Introduce un nombre"),
		email: Yup.string().required("Introduce un email")
	});

	const methods = useForm<CreateClientForm>({
		resolver: yupResolver(schema),
		defaultValues: { clientName: "", email: "" }
	});

	const { onCreateClient, isLoading } = useCreateClient();

	async function onSubmit({ clientName, email }: CreateClientForm) {
		onCreateClient(clientName, email);
		methods.reset();
	}

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		isLoading
	};
}
